import { render } from "./Dropdown3.vue?vue&type=template&id=a1e2ba7e&ts=true"
import script from "./Dropdown3.vue?vue&type=script&lang=ts"
export * from "./Dropdown3.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/www-root/data/www/brazilist-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__